<app-admin-toast></app-admin-toast>
<div class="padding-component">
    <app-header [title]="'Auditorías'"></app-header>

    <mat-tab-group [selectedIndex]="selectedIndex">
        <mat-tab label="Auditorias"><app-audits></app-audits></mat-tab>
        <mat-tab label="Hallazgos"><app-findings></app-findings></mat-tab>
        <mat-tab label="Acciones Correctivas"><app-corrective-actions></app-corrective-actions></mat-tab>
    </mat-tab-group>
</div>